import * as React from 'react';
import { RouteProps } from 'react-router';
import { Helmet } from 'react-helmet';

import { withAsyncFeatures } from 'core';

import * as features from 'features';

import { ErrorBoundary } from 'services/ErrorTracking';
import { Alert } from 'services/Alert';
import { getHelmetTale } from 'shared/helpers';

interface IFeatureProps {
  ExportCabinet: features.ExportCabinet.Entry;
}

type IProps = RouteProps & IFeatureProps;


class PrepareMediaplanToExportCabinetPage extends React.PureComponent<IProps> {
  public render() {
    const { ExportCabinet, location } = this.props;

    return (
      <>
        <Helmet defer={false}>
          <title>Создание РК MyTarget - {getHelmetTale()} Client Space</title>
        </Helmet>
        <ErrorBoundary>
          <Alert />
          <ExportCabinet.containers.PrepareMediaplan searchParams={location?.search} />
        </ErrorBoundary>
      </>
    );
  }
}

export const PrepareMediaplanToExportCabinet = (
  withAsyncFeatures({ ExportCabinet: features.ExportCabinet.loadEntry })(PrepareMediaplanToExportCabinetPage)
);
